"use client";

import { useState } from "react";

export default function SocialMediaForm({ value, onChange }: any) {
  const [form, setForm] = useState(
    value || {
      instagram: "",
      tiktok: "",
      facebook: "",
      linkedin: "",
    }
  );

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const updated = { ...form, [name]: value };
    setForm(updated);

    if (onChange) onChange(updated);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

      <div className="flex flex-col gap-1">
        <label className="font-medium">Instagram</label>
        <input
          type="text"
          name="instagram"
          placeholder="Instagram URL"
          value={form.instagram || ""}
          onChange={handleChange}
          className="p-3 border rounded-lg"
        />
      </div>

      <div className="flex flex-col gap-1">
        <label className="font-medium">Tiktok</label>
        <input
          type="text"
          name="tiktok"
          placeholder="Tiktok URL"
          value={form.tiktok || ""}
          onChange={handleChange}
          className="p-3 border rounded-lg"
        />
      </div>

      <div className="flex flex-col gap-1">
        <label className="font-medium">Facebook</label>
        <input
          type="text"
          name="facebook"
          placeholder="Facebook URL"
          value={form.facebook || ""}
          onChange={handleChange}
          className="p-3 border rounded-lg"
        />
      </div>

      <div className="flex flex-col gap-1">
        <label className="font-medium">LinkedIn</label>
        <input
          type="text"
          name="linkedin"
          placeholder="LinkedIn URL"
          value={form.linkedin || ""}
          onChange={handleChange}
          className="p-3 border rounded-lg"
        />
      </div>

    </div>

  );
}
